import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import { NotoficationsRoutingModule } from './notofications-routing.module';
import { DisplayPictureModule } from '@app/modules/trading/modules/profile/components/user/display-picture/display-picture.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule, MatLegacySpinner as MatSpinner } from '@angular/material/legacy-progress-spinner';
import { MbPlansModule } from '../../../mb-plans/mb-plans.module';



@NgModule({
  declarations: [NotificationsComponent, NotificationCardComponent],
  imports: [
    CommonModule,
    NotoficationsRoutingModule,
    DisplayPictureModule,
    MatIconModule,
    MatDialogModule,
    MatTabsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MbPlansModule,
    ],
  exports: [NotificationsComponent]
})
export class NotificationsModule { }
